import Component from '../component';

export default class InstagramFeed extends Component {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/instagram-feed/instagram-feed.js